<template>
  <div class="popMain" v-show="isshow">
    <div class="ipt">
      <p @click="goMember">立即购买</p>
      <div class="cancel" @click="hidePop">X</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isshow: true,
    }
  },
  computed: {
    ...mapGetters(["GET_USER_INFO"]),
  },
  created () {
    this.isshow = this.isShow
  },

  methods: {
    hidePop () {
      this.isshow = false;
    },
    goMember () {
      if (this.GET_USER_INFO.token === '') { // 用户没登录
        this.$router.push({ path: '/member' })
        this.isshow = false;
      } else { // 用户已登录
        this.$router.push({ path: '/memberLogined' })
        this.isshow = false;
      }
    }


  }
}
</script>

<style lang="less" scoped>
.ipt {
  width: 400px;
  height: 420px;
  // width: 500px;
  // height: 500px;
  background-image: url("../../assets/member/openPopUp.png");
  background-size: contain;
  background-position: -100% -100%;
  background-repeat: no-repeat;
  user-select: none;

  .cancel {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.6);
    color: #ccc;
    position: absolute;
    right: -10px;
    top: -10px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }

  p {
    width: 200px;
    height: 40px;
    background-color: rgb(230, 199, 119);
    border-radius: 40px;
    text-align: center;
    line-height: 40px;
    position: absolute;
    left: 100px;
    bottom: 80px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>